import { forwardRef } from 'react';

import styled from '@emotion/styled';

import { SearchBar as DesignSystemSearchBar } from '@myrealtrip/web-ui';

interface Props {
  query: string;
  onChange: (value: string) => void;
}

const SearchBar = forwardRef<HTMLInputElement, Props>(({ query, onChange }, ref) => {
  return (
    <StyledSearchBar
      ref={ref}
      fullWidth
      placeholder="도시 또는 역 입력"
      value={query}
      onChange={onChange}
    />
  );
});

SearchBar.displayName = 'SearchBar';

const StyledSearchBar = styled(DesignSystemSearchBar)`
  border-radius: 0;
  background-color: ${({ theme }) => theme.colors.white};

  & input {
    ${({ theme }) => theme.typography.paragraphBold15};
    border: 1.5px solid ${({ theme }) => theme.colors.gray.s200};
    border-radius: 12px;

    :focus {
      background-color: ${({ theme }) => theme.colors.white};
      border-radius: 12px;
      border: 1.5px solid ${({ theme }) => theme.colors.blue.s600};
    }

    &::placeholder {
      ${({ theme }) => theme.typography.paragraphBold15};
      color: ${({ theme }) => theme.colors.gray.s400};
    }
  }
`;

export default SearchBar;
